<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-26 09:32:32
-->
<template>
  <el-breadcrumb separator="">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        v-for="(item,index) in crumbList"
        :key="item.path">
        <span v-if="index==1" v-html="item.meta.cate+'&nbsp; / '+'&nbsp;'+item.meta.title" style="color:#2c343f "> </span>
        <!-- <router-link :to="item.redirect||item.path||'/'">{{item.meta.cate}} / {{item.meta.title}}</router-link> -->
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>
ll
<script>
export default {
  data() {
    return {
      crumbList: null
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta.title)
      this.crumbList = matched
    }
  },
  created: function () {
    this.getBreadcrumb()
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-breadcrumb
  margin-bottom 16px
</style>
